import { TrashIcon } from "@xola/icons";
import { Table } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React, { useState } from "react";
import { Experience, Schedule } from "types";
import { getDefaultScheduleForExperience } from "../../models/Schedule";
import { ScheduleEditorModal } from "../Product/SchedulesAvailability/ScheduleEditorModal";
import { ScheduleRow } from "./ScheduleRow";

interface ScheduleTableProps {
    schedules: Schedule[];
    experience?: Experience;
    showCreateModal: boolean;
    activeButton: number;
    onCreateModalVisibilityToggle: () => void;
    onCreate: (values: Schedule, priceVariationData: any) => void;
    onEdit: (values: Schedule, priceVariationData: any) => void;
    onBeforeEdit?: (values: Schedule) => Promise<Schedule | false>;
    onDelete: (scheduleId: ID) => void;
    setIsAllDelete: (isAll: boolean) => void;
    blackoutSchedules?: boolean;
}

export const ScheduleTable = ({
    schedules,
    experience,
    showCreateModal,
    activeButton,
    onCreateModalVisibilityToggle,
    onCreate,
    onEdit,
    onBeforeEdit,
    onDelete,
    setIsAllDelete,
    blackoutSchedules = false,
}: ScheduleTableProps) => {
    const [selectedSchedule, setSelectedSchedule] = useState<Schedule | null>(null);
    return (
        <>
            {schedules?.length > 0 ? (
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Header className="!text-sm">Schedule Name</Table.Header>
                            {blackoutSchedules ? null : (
                                <Table.Header className="text-center !text-sm">Price Variation</Table.Header>
                            )}
                            <Table.Header className="whitespace-nowrap text-right !text-sm">
                                {activeButton === 1 && blackoutSchedules ? (
                                    <SecondaryButton
                                        size="tiny"
                                        onClick={() => {
                                            if (schedules[0].id) {
                                                onDelete(schedules[0].id);
                                                setIsAllDelete(true);
                                            }
                                        }}
                                    >
                                        <div className="space-x-1">
                                            <TrashIcon /> <span>Delete All</span>
                                        </div>
                                    </SecondaryButton>
                                ) : (
                                    "Actions"
                                )}
                            </Table.Header>
                        </Table.Row>
                    </Table.Head>

                    <Table.Body>
                        {schedules?.map((schedule: any) => {
                            return (
                                <ScheduleRow
                                    key={schedule.id}
                                    schedule={schedule}
                                    blackoutSchedules={blackoutSchedules}
                                    setSelectedSchedule={setSelectedSchedule}
                                    onRemove={onDelete}
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            ) : null}

            <ScheduleEditorModal
                disablePastDays
                title={blackoutSchedules ? "Blackout Schedule" : "Available Schedule"}
                isOpen={showCreateModal}
                initialValues={getDefaultScheduleForExperience(experience, blackoutSchedules)}
                blackoutSchedules={blackoutSchedules}
                experience={experience}
                showAvailability={false}
                onApply={onCreate}
                onClose={onCreateModalVisibilityToggle}
            />

            {selectedSchedule && (
                <ScheduleEditorModal
                    disablePastDays
                    isOpen // Because `selectedSchedule` is always true due to the above if-condition
                    title="Schedule"
                    initialValues={selectedSchedule}
                    blackoutSchedules={blackoutSchedules}
                    experience={experience}
                    showAvailability={false}
                    onApply={onEdit}
                    onBeforeApply={onBeforeEdit}
                    onClose={() => setSelectedSchedule(null)}
                />
            )}
        </>
    );
};
